import cx from "classnames";

import { Logo } from "@/components/Logo";

import "./Header.scss";

type HeaderProps = {
  fullWidth?: boolean;
  className?: string;
  children?: React.ReactNode;
  fixed?: boolean;
  customLogo?: React.ReactNode;
};

const Header: React.FC<HeaderProps> = ({
  fullWidth = false,
  className,
  children,
  fixed = true,
  customLogo,
}) => {
  return (
    <header
      className={cx(
        className,
        {
          "Header--Fixed": fixed,
        },
        "Header",
      )}
    >
      <div
        className={cx("Header__Container", {
          "Header__Container--FullWidth": fullWidth,
        })}
      >
        {customLogo ? customLogo : <Logo className="Header__Container__Logo" />}
        <div className="Header__Container__Content">{children}</div>
      </div>
    </header>
  );
};

export { Header };
